(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elara-welcome-offer"] && !Shopify.designMode) return;
  try {
    (()=>{const panel=document.getElementById('ElaraWelcomeOffer');if(!panel)return;const key='elara_welcome_offer_v1';const get=k=>{try{return localStorage.getItem(k)}catch{return null}};const set=(k,v)=>{try{localStorage.setItem(k,v)}catch{}};const close=()=>{panel.hidden=true;set(key,'dismissed')};panel.querySelector('.elara-welcome__close').addEventListener('click',close);panel.addEventListener('keydown',e=>{if(e.key==='Escape')close()});if(panel.querySelector('[data-welcome-success]')){set('elara_newsletter_subscribed','yes');set(key,'subscribed');panel.hidden=false;return}if(panel.querySelector('[data-welcome-error]')){panel.hidden=false;return}if(get(key)||get('elara_newsletter_subscribed'))return;let count=Number(get('elara_welcome_pages')||0)+1;set('elara_welcome_pages',String(count));const show=()=>{if(document.hidden||document.querySelector('dialog[open],.drawer--is-open')||document.activeElement?.matches('input,textarea,select')){setTimeout(show,5000);return}if(get(key)||get('elara_newsletter_subscribed'))return;panel.hidden=false;set(key,'shown')};setTimeout(show,count>1?10000:25000)})();
  } catch(e) { console.error(e); }
})();

})();
